import { OperationOutcomeError, operationOutcomeToString } from '@medplum/core';

/** Generic message — must not reveal whether an account/profile exists. */
export const GENERIC_SIGN_IN_FAILURE = 'Email or password is invalid';

function isInactiveProfileLoginError(message: string): boolean {
  return /^profile not active$/i.test(message.trim());
}

/** Map Medplum login errors that leak account state to a generic failure message. */
export function sanitizeSignInErrorMessage(message: string): string {
  if (isInactiveProfileLoginError(message)) {
    return GENERIC_SIGN_IN_FAILURE;
  }
  return message;
}

export function isInactiveProfileSignInError(message: string): boolean {
  return isInactiveProfileLoginError(message);
}

export function extractSignInErrorMessage(err: unknown): string {
  if (err instanceof OperationOutcomeError) {
    return operationOutcomeToString(err.outcome);
  }
  if (err instanceof Error) {
    return err.message;
  }
  return String(err);
}

export function formatSignInError(err: unknown): string {
  const raw = extractSignInErrorMessage(err) || 'Failed to sign in';
  return sanitizeSignInErrorMessage(raw);
}
